import ColourSwatch from "./ColourSwatch";
export default ColourSwatch;
